<template>
  <BaseDialog :is-open="isOpen" type="basic" @close="emits('close')">
    <div>
      <ul class="flex flex-col gap-6 pt-2">
        <li v-for="feedbackTopic in feedbackTopics" :key="feedbackTopic.id">
          <div class="text-on-surface-variant flex flex-row items-center gap-2 py-4">
            <BaseIcon>{{ feedbackTopic.icon }}</BaseIcon>
            <h3 class="text-title-large text-on-surface-variant">{{ feedbackTopic.title }}</h3>
            <span class="text-label-medium text-on-surface-variant ml-auto"
              >{{ feedbackTopic.questionGroups.flatMap((group) => group.questions).length }}
              {{
                $t('common.question', {
                  count: feedbackTopic.questionGroups.flatMap((group) => group.questions).length,
                })
              }}</span
            >
          </div>
          <ul class="flex flex-col gap-3">
            <li v-for="questionGroup in feedbackTopic.questionGroups" :key="questionGroup.id">
              <div
                class="mb-1.5 flex w-full flex-row items-center justify-between gap-2 overflow-hidden"
              >
                <h4
                  v-if="questionGroup.title"
                  class="text-title-small text-on-surface-variant shrink grow overflow-hidden text-ellipsis"
                >
                  {{ questionGroup.title }}
                </h4>
                <div
                  v-tooltip="
                    $t('feedbackType.' + questionGroup.feedbackType) +
                    (questionGroup.feedbackType === FeedbackType.ScaleBased
                      ? ': ' +
                        questionGroup.scale.items[0]!.label +
                        ' - ' +
                        questionGroup.scale.items[questionGroup.scale.items.length - 1]!.label
                      : '')
                  "
                  class="ml-auto flex shrink items-center justify-end overflow-hidden"
                >
                  <span
                    v-if="questionGroup.feedbackType === FeedbackType.ScaleBased"
                    class="text-body-small flex shrink gap-1 overflow-hidden whitespace-nowrap"
                  >
                    <span class="overflow-hidden text-ellipsis">
                      {{ questionGroup.scale.items[0]!.label }}
                    </span>
                    <span> - </span>
                    <span class="overflow-hidden text-ellipsis">
                      {{ questionGroup.scale.items[questionGroup.scale.items.length - 1]!.label }}
                    </span>
                  </span>
                  <div
                    class="text-on-primary-container bg-primary-container ml-1.5 h-6 shrink-0 rounded-full px-1"
                  >
                    <BaseIcon size="22" class="">{{
                      questionGroup.feedbackType === FeedbackType.ScaleBased
                        ? 'linear_scale'
                        : 'short_text'
                    }}</BaseIcon>
                  </div>
                </div>
              </div>
              <ul class="flex flex-col gap-0.5">
                <li
                  v-for="question in questionGroup.questions"
                  :key="question.id"
                  class="bg-surface rounded-extra-small first:rounded-t-large last:rounded-b-large flex flex-row p-4"
                >
                  <p class="text-body-large text-on-surface-variant">
                    {{ question.content }}
                  </p>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <template #dismiss
      ><BaseTextButton color="text" @click="emits('close')">{{
        $t('common.close')
      }}</BaseTextButton>
    </template>
  </BaseDialog>
</template>
<script lang="ts" setup>
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import BaseTextButton from '../../../core/components/base/button/text-button/BaseTextButton.vue'
  import BaseDialog from '../../../core/components/base/dialog/BaseDialog.vue'
  import { FeedbackType } from '@/core/models/feedback-type.ts'
  import type { QuestionGroup } from '@/modules/give-feedback/models/question-group.ts'

  interface Props {
    isOpen: boolean
    feedbackTopics: ReadonlyArray<{
      id: string
      title: string
      icon?: string
      questionGroups: ReadonlyArray<QuestionGroup>
    }>
  }

  const { feedbackTopics } = defineProps<Props>()

  const emits = defineEmits<{
    (e: 'close'): void
  }>()
</script>
